export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/44c6d76e0cdfa3611cbcbbc72edc8e34.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950/85 via-slate-900/75 to-slate-800/70"></div>
      </div>

      {/* Floating decorative shapes */}
      <div className="absolute top-1/4 right-1/4 w-64 h-64 rounded-full bg-cyan-500/5 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-1/3 left-1/5 w-96 h-96 rounded-full bg-teal-500/5 blur-3xl pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col lg:flex-row items-center gap-12 pt-24 pb-16">
        {/* Left Text */}
        <div className="flex-1 text-center lg:text-left">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 flex items-center justify-center">
              <span className="block w-2 h-2 rounded-full bg-cyan-400 animate-pulse"></span>
            </span>
            <span className="text-cyan-300 text-xs font-medium tracking-widest uppercase">iOS Platform Specialists</span>
          </div>

          <h1
            className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Crafting Premium
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-teal-300">
              iOS Applications
            </span>
            <br />
            For Modern Users
          </h1>

          <p className="text-lg md:text-xl text-slate-300 max-w-xl mx-auto lg:mx-0 leading-relaxed mb-10">
            VITEK D.O.O. is a team of experts building next-generation mobile applications — from powerful VPN solutions to intelligent device cleaners — engineered for performance, privacy, and simplicity.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <button
              onClick={() => handleScroll('#products')}
              className="px-8 py-3 rounded-full bg-cyan-500 hover:bg-cyan-400 text-white font-semibold text-sm tracking-wide transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Explore Our Products
            </button>
            <button
              onClick={() => handleScroll('#about')}
              className="px-8 py-3 rounded-full border border-white/30 hover:border-white/60 text-white font-semibold text-sm tracking-wide transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Learn More
            </button>
          </div>
        </div>


      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-xs text-white/40 tracking-widest uppercase">Scroll</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/40"></i>
        </div>
      </div>
    </section>
  );
}
